import React, { memo, useCallback } from 'react';
import { Dialog, DialogContent, DialogTitle } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { Reply } from '@app/models';
import { ReplyDetail } from '@app/common';
import { fullName } from '@app/helpers';

interface Props {
  reply: Reply | null;
  visible: boolean;
  onClose: (reply?: Reply) => void;
  onChange?: (id: string, isChange: boolean) => void;
}

function ModalReplyDetail(props: Props) {
  const { visible, reply, onClose, onChange } = props;

  const closeModal = useCallback(() => {
    onClose();
  }, [onClose]);

  const onUpdateReply = useCallback(
    (reply: Reply) => {
      onClose(reply);
      if (!!onChange) {
        onChange(reply.id, !reply.pinned);
      }
    },
    [onChange, onClose]
  );

  return (
    <Dialog
      open={visible}
      onOpenChange={(open) => {
        if (!open) closeModal();
      }}
    >
      <DialogContent className="max-w-4xl max-h-[90vh] min-h-0 flex flex-col p-0">
        <DialogTitle className="pr-10 max-w-[calc(100%-3rem)] truncate px-6 pt-6 pb-2 flex-shrink-0">
          {reply ? `Автор отклика: ${fullName(reply.owner)}` : ''}
        </DialogTitle>
        {/** Removed local close button; the dialog provides a built-in one */}
        <div className="flex-1 min-h-0 overflow-y-auto px-6 pb-6">
          {reply && <ReplyDetail reply={reply} onUpdate={onUpdateReply} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default memo(ModalReplyDetail);
